module.exports = __webpack_public_path__ + "media/images/phone-confirmation-e4ae4d10bc9a2637e08ec52658ba91d7.png";